import api from '@/lib/services/general.service'

const initialState = () => ({
  isLoading: false,
  elapsedSeconds: 0,
  totalQueued: 0,
  displaySeconds: 0,
  ticker: null,
  pollInterval: null,
})

export const state = initialState()

export const getters = {
  isLoading: s => s.isLoading,
  elapsedSeconds: s => s.elapsedSeconds,
  displaySeconds: s => s.displaySeconds,
  totalQueued: s => s.totalQueued,
}

export const actions = {
  async startRebase({ commit, dispatch }) {
    const response = await api.insert('sync/rebase-to-google', {})
    if (response?.data) {
      commit('SET_STATUS', response.data)
      if (response.data.isLoading) {
        commit('START_TICKER')
        dispatch('startPolling')
      }
    }
  },

  async checkStatus({ commit }) {
    const response = await api.get('sync/rebase-to-google-status', {})
    if (response?.data) {
      commit('SET_STATUS', response.data)
      if (!response.data.isLoading) {
        commit('STOP_TICKER')
        commit('STOP_POLL')
      }
    }
  },

  startPolling({ commit, dispatch }) {
    commit('STOP_POLL')
    const interval = setInterval(() => {
      dispatch('checkStatus')
    }, 10000)
    commit('SET_POLL', interval)
  },
}

export const mutations = {
  SET_STATUS(s, status) {
    s.isLoading = status.isLoading
    s.elapsedSeconds = status.elapsedSeconds ?? 0
    if (status.totalQueued != null) s.totalQueued = status.totalQueued
    if (!status.isLoading) {
      s.displaySeconds = 0
    }
  },

  START_TICKER(s) {
    if (s.ticker) clearInterval(s.ticker)
    s.ticker = setInterval(() => {
      s.displaySeconds += 1
    }, 1000)
  },

  STOP_TICKER(s) {
    if (s.ticker) {
      clearInterval(s.ticker)
      s.ticker = null
    }
    s.displaySeconds = 0
  },

  SET_POLL(s, interval) {
    s.pollInterval = interval
  },

  STOP_POLL(s) {
    if (s.pollInterval) {
      clearInterval(s.pollInterval)
      s.pollInterval = null
    }
  },
}

export default { state, getters, actions, mutations }
